import { useEffect, useRef } from 'react';

const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  // Remember last callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // set up interval
  useEffect(() => {
    if (delay !== null) {
      const id = setInterval(() => {
        savedCallback.current();
      }, delay);
      return () => clearInterval(id);
    }
    return null;
  }, [delay]);
};

export default useInterval;
